import i18next from "i18next";
import { Moment } from "moment-timezone";
import { classNames } from "../../helpers";

type ScheduleCalendarDatesHeaderItemProps = {
  date: Moment;
  isSelected: Boolean;
  compact?: Boolean;
  showDates?: Boolean;
  onChangeViewingDate: (date: Moment) => void;
};

export default function ScheduleCalendarDatesHeaderItem(
  props: ScheduleCalendarDatesHeaderItemProps
) {
  let {
    date,
    isSelected,
    onChangeViewingDate,
    compact = false,
    showDates = true,
  } = props;

  const onGoToDate = () => {
    onChangeViewingDate(date);
  };
  const containerClass = "flex items-center justify-center py-4 gap-1";
  const compactContainerClasses = "flex flex-col items-center pt-2 pb-3";

  let colorClasses = "text-gray-900";
  if (isSelected) colorClasses = "rounded-full bg-brandblue-600 text-white";

  let dateFormat = "dd";
  if (!compact) dateFormat = i18next.language === "ar" ? "dddd" : "ddd";

  return (
    <button
      type="button"
      className={classNames(
        compact ? compactContainerClasses : containerClass,
        isSelected ? "bg-brandblue-100 text-gray-700" : "text-gray-400",
        "text-sm leading-6 font-medium"
      )}
      onClick={onGoToDate}
    >
      {date.format(dateFormat)}
      {showDates && (
        <span
          className={`${
            compact ? "mt-1" : ""
          } flex h-8 w-8 items-center justify-center text-base font-semibold ${colorClasses}`}
        >
          {date.format("DD")}
        </span>
      )}
    </button>
  );
}
